import React from 'react';
import { Search } from 'lucide-react';
import ContentSearch from '../ui/ContentSearch';

const SearchPage: React.FC = () => {
  return (
    <div className="content">
    <div className="container mx-auto px-4 py-8 max-w-6xl">
      <div className="mb-8">
        <div className="flex items-center space-x-3 mb-2">
          <div className="p-2 bg-[#4ff6e6]/10 rounded-lg">
            <Search className="w-6 h-6 text-[#4ff6e6]" />
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-white">Content Search</h1>
        </div>
        <p className="text-[#bbb] text-sm md:text-base">Search through market sentiment content and discussions</p>
      </div>
      <ContentSearch />
    </div>
    </div>
  );
};

export default SearchPage; 